import { LogOut } from "lucide-react";
import React from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface LogoutConfirmationPageProps {
  open?: boolean;
  onLogout: () => void;
  onCancel: () => void;
}

export default function LogoutConfirmationPage({ open = true, onLogout, onCancel }: LogoutConfirmationPageProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) onCancel();
      }}
    >
      <DialogContent className="max-w-md w-full">
        <DialogHeader className="items-center text-center">
          <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mb-2">
            <LogOut size={28} className="text-foreground" />
          </div>
          <DialogTitle>Déconnexion</DialogTitle>
          <DialogDescription>
            Voulez-vous vraiment vous déconnecter ? Vous devrez vous reconnecter pour gérer vos stocks.
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="gap-2 sm:gap-3">
          <Button variant="outline" onClick={onCancel}>
            Annuler
          </Button>
          <Button variant="destructive" onClick={onLogout}>
            Se déconnecter
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
